import { render, staticRenderFns } from "./reset-form.component.vue?vue&type=template&id=675585fe"
import script from "./reset-form.component.vue?vue&type=script&lang=js"
export * from "./reset-form.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports